<template>
  <div class="container py-5">

    <h2 class="page-title mb-4">Programming</h2>

    <p class="lead">
      Programming is the process of creating instructions that a computer can
      understand and execute.
    </p>

    <div class="card-section mt-4">
      <h4 class="section-title">🧠 What is Programming?</h4>
      <p>
        It involves writing code to perform tasks, solve problems, or automate processes.
      </p>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">💻 Popular Programming Languages</h4>
      <ul>
        <li>Python</li>
        <li>JavaScript</li>
        <li>Java</li>
        <li>C#</li>
        <li>C++</li>
      </ul>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">🎯 Why Learn Programming?</h4>
      <ul>
        <li>High demand in tech industry</li>
        <li>Build apps, websites, games</li>
        <li>Improve logical thinking</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "ComputerProgramming",
};
</script>

<style scoped>
.page-title { font-weight: 800; color: #2563eb; }
.lead { color: #374151; font-size: 1.1rem; }
.card-section {
  background: #fff; padding: 20px; border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border-left: 4px solid #2563eb;
}
.section-title { color: #1e40af; font-weight: 600; }
</style>
